module.exports = __webpack_public_path__ + "static/media/arrowUp.31bfc33a.svg";